export default "__VITE_ASSET__81f5df24__"